const income = {
  id: 0,
  income_group_id: 0,
  name: '',
  team_id: 0,
  expense_type_id: 0,
  price: 0,
  invoice_type: -1,
  tax: 0,
  tax_rate: 0,
  remark: '',
};

const income_group = {
  id: 0,
  fill_user_id: 0,
  fill_user: '',
  apply_user_id: 0,
  apply_user: '',
  receipt_type: 0,
  bill_type: '',
  receipt_purpose_uid: '',
  name: '',
  uid: '',
  company_id: 0,
  receipt_bank_id: 0,
  currency: '',
  unit_type: '',
  client_id: 0,
  payee_company_id: 0,
  staff_id: 0,
  opposite_bank_name: '',
  opposite_bank_number: '',
  opposite_account_name: '',
  total_price: 0,
  receipted_at: '',
  remark: '',
  incomes: [income]
};

export const INCOME = income;
export const INCOME_GROUP = income_group;
